import React, { useEffect } from 'react';
import { pr2026 } from '../../json/pr2026';
import './ed.css';


const Pr2026 = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div className='container'>
        <div className='row'>
            <div>
                <h3 className='title'>Sistema de Evaluación del Desempeño</h3>
                <hr className='hr-gob'/>

                 <p>El propósito de este sistema es Establecer un marco integral de evaluación y mecanismos de monitoreo a los programas presupuestarios de la Secretaría de Turismo durante sus ejercicios fiscales, con la finalidad de transparentar y rendir cuentas del desempeño institucional</p>   



            </div>
                {
                pr2026.map((item, index)=>(
                    <div key={ index } className='col-md-3 col-sm-6 col-12'>
                        <div className='card_container_ed'>
                            <div className='card_anio'>
                                <h5>{ item.anio }</h5>
                                <h6>{ item.descripcion }</h6>
                                {
                                    item.trimestres.map((trim, index)=>(
                                        <div key={ index } className='card_trimestre'>
                                            <p>{ trim.trimestre } <span className="badge bg-secondary">
                                                <a href={ trim.url } target="">.ver</a></span>
                                            </p> 
                                        </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>
                    ))
                }
        </div>
  
    </div>
  )
}

export default Pr2026